import script from "./confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm.vue?vue&type=script&setup=true&lang=js"

import "./confirm.vue?vue&type=style&index=0&id=0db6c5f8&lang=less"

const __exports__ = script;

export default __exports__